import { Card, Grid, Progress, Table, type TableColumnsType } from 'antd';
import type { TaskStatisticsOutputDto } from '../model';
import { getSuccessPercent, getSuccessRateColor } from '../utils/success-rate';
import { accountNameColumn } from './account-name-column';

const columns: TableColumnsType<
  TaskStatisticsOutputDto['account_stats'][number]
> = [
  accountNameColumn,
  {
    title: '成功',
    dataIndex: 'succeeded',
  },
  {
    title: '失败',
    dataIndex: 'failed',
  },
  {
    title: '其他',
    dataIndex: 'other',
  },
  {
    title: '脚本数',
    dataIndex: 'script_count',
  },
  {
    title: '成功率',
    key: 'success_rate',
    render: (_, record) => {
      const percent = getSuccessPercent(
        record.succeeded,
        record.failed,
        record.other,
      );

      return (
        <Progress
          percent={percent}
          strokeColor={getSuccessRateColor(percent)}
          size="small"
        />
      );
    },
  },
];

export function AccountStatisticsTable(props: {
  data: TaskStatisticsOutputDto['account_stats'];
}) {
  const { xs } = Grid.useBreakpoint();

  return (
    <Card title="账户统计">
      <Table
        rowKey={(record) => record.created_by ?? record.account_id}
        size="small"
        scroll={xs ? { x: 800 } : void 0}
        columns={columns}
        dataSource={props.data}
        pagination={{ defaultPageSize: 10 }}
      />
    </Card>
  );
}
